<template>
  <a-card :bordered="false">
    <div class="queryView">
      <div class="queryView-actions">
        <a-button type="primary" icon="plus-circle" @click="add()">新增</a-button>
      </div>
      <div class="queryView-main">
        <a-table
          class="queryView-table"
          rowKey="id"
          bordered
          :loading="loading"
          :columns="tableColumns"
          :dataSource="dataSource"
          :expandIconColumnIndex="0"
          :pagination="false"
          size="middle"
        ></a-table>
      </div>
    </div>
    <!-- 添加/编辑弹框 -->
    <a-modal :title="modal.title" v-model="modal.visible" @ok="handleOk">
      <a-form :form="modal.form" v-bind="modalFormLayout">
        <a-form-item label="父级">
          <a-tree-select
            allowClear
            v-decorator="['parentId']"
            class="input"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="menuTree.treeData"
            :replaceFields="menuTree.replaceFields"
            placeholder="请选择父级"
          ></a-tree-select>
        </a-form-item>
        <a-form-item label="名称">
          <a-input
            v-decorator="[
              'menuName',
              {
                rules: [{ required: true, message: '请输入名称' }],
              },
            ]"
            placeholder="请输入名称"
          ></a-input>
        </a-form-item>
        <a-form-item label="类型">
          <a-select
            v-decorator="[
              'menuType',
              {
                rules: [{ required: true, message: '请选择类型' }],
              },
            ]"
            placeholder="请选择类型"
            :options="typesMap.menuType"
          ></a-select>
        </a-form-item>
        <a-form-item label="图标">
          <a-input v-decorator="['menuIcon']" placeholder="请输入图标"></a-input>
        </a-form-item>
        <a-form-item label="权限编码">
          <a-input
            v-decorator="[
              'authCode',
              {
                rules: [{ required: true, message: '请输入权限编码' }],
              },
            ]"
            placeholder="请输入权限编码"
          ></a-input>
        </a-form-item>
        <a-form-item label="所属系统">
          <a-select
            v-decorator="[
              'type',
              {
                rules: [{ required: true, message: '请选择所属系统' }],
              },
            ]"
            placeholder="请选择所属系统"
            :options="typesMap.type"
          ></a-select>
        </a-form-item>

        <a-form-item label="路径">
          <a-input v-decorator="['menuUrl']" placeholder="请输入菜单路径"></a-input>
        </a-form-item>
        <a-form-item label="排序号">
          <a-input-number
            v-decorator="[
              'orderIndex',
              {
                rules: [{ required: true, message: '请输入排序号' }],
              },
            ]"
            :min="1"
            :precision="0"
            placeholder="请输入排序号"
          ></a-input-number>
        </a-form-item>
        <a-form-item hidden>
          <a-input
            v-decorator="[
              'authLevelCode',
              {
                initialValue: TOP_LEVEL,
              },
            ]"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { queryViewMixin } from '@/utils/mixin'
import { getSystemType } from '@/service/getUnifyData'
export default {
  name: 'MenuManage',
  mixins: [queryViewMixin],
  data() {
    const tableColumns = [
      {
        title: '名称',
        width: '35%',
        dataIndex: 'menuName',
        customRender: (text, row) => {
          return (
            <span class="menu-name">
              {text}
              {row.mHide && <span class="text-gray-400">【已隐藏】</span>}
            </span>
          )
        },
      },
      {
        title: '权限编码',
        width: '8%',
        dataIndex: 'authCode',
      },
      {
        title: '所属系统',
        width: '8%',
        dataIndex: 'type',
      },
      {
        title: '类型',
        width: '8%',
        dataIndex: 'menuType',
        customRender: (text) => {
          return (
            <div>
              {text === 'M' && <a-tag color="green">目录</a-tag>}
              {text === 'C' && <a-tag color="blue">菜单</a-tag>}
              {text === 'A' && <a-tag color="purple">按钮</a-tag>}
            </div>
          )
        },
      },
      {
        title: '路径',
        width: '15%',
        dataIndex: 'menuUrl',
      },
      {
        title: '排序号',
        width: '5%',
        align: 'center',
        dataIndex: 'orderIndex',
      },
      {
        title: '操作',
        width: '15%',
        align: 'center',
        dataIndex: 'detail',
        customRender: (text, row, index) => {
          return (
            <div>
              <a
                class="row-action-btn"
                onClick={() => {
                  this.add(row)
                }}
              >
                新增
              </a>
              <a
                class="row-action-btn"
                onClick={() => {
                  this.doEdit(row)
                }}
              >
                修改
              </a>
              {row.mBuilt || (
                <a
                  class="row-action-btn"
                  onClick={() => {
                    this.doDelete(row)
                  }}
                >
                  删除
                </a>
              )}
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      loading: false,
      tableColumns: tableColumns,
      dataSource: [],
      modal: {
        visible: false,
        data: {},
        form: this.$form.createForm(this),
        title: '',
      },

      // 页面初始化数据
      menuTree: {
        treeData: [],
        replaceFields: { children: 'children', title: 'menuName', value: 'id' },
      },
      systemType: [],
      TOP_LEVEL: 2,
      TOP_PARENT_ID: 1,
    }
  },
  computed: {
    typesMap() {
      return {
        menuType: [
          // 目录的url不会和本地的路由关联
          { value: 'M', label: '目录' },
          { value: 'C', label: '菜单' },
          { value: 'A', label: '按钮' },
        ],
        openType: [
          { value: 'NB', label: '当前页面' },
          { value: 'WB', label: '新开窗口' },
        ],
        type: [
          { value: 'web', label: 'web' },
          { value: 'aie', label: 'aie' },
          { value: 'app', label: 'app' },
        ],
      }
    },
    modalFormLayout() {
      return {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      }
    },
  },

  methods: {
    add(row) {
      this.resetModal()
      this.modal.visible = true
      this.modal.title = '新增'

      if (row) {
        this.safeSetFieldsValue(this.modal.form, {
          parentId: row.id,
          authLevelCode: row.authLevelCode + 1,
        })
      }
    },
    async doDelete(row) {
      await new Promise((resolve, reject) => {
        this.$confirm({
          title: '提示',
          content: '确定删除记录?',
          onOk: () => {
            resolve()
          },
          onCancel: () => {
            reject(new Error('E_CANCEL'))
          },
        })
      })
      await this.$axios.delete(`/ums/menu/del`, {
        params: {
          id: row.id,
        },
      })
      this.$message.success('操作成功!')
      this.loadMenu()
    },
    doEdit(row) {
      this.resetModal()
      this.modal.visible = true
      this.modal.title = '修改'
      const data = { ...row }
      if (data.parentId === this.TOP_PARENT_ID) {
        data.parentId = null
      }

      this.modal.data = data
      this.safeSetFieldsValue(this.modal.form, data)
    },
    handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        console.log(values)
        if (!errors) {
          const params = { ...values, authName: values.authName || values.menuName }

          const { id } = this.modal.data
          try {
            if (!id) {
              await this.$axios.post('/ums/menu/add', {
                ...params,
              })
            } else {
              await this.$axios.put('/ums/menu/update', {
                id,
                ...params,
              })
            }

            this.$message.success('操作成功!')
            this.modal.visible = false
            this.loadMenu()
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    async loadMenu() {
      this.loading = true
      try {
        const res = await this.$axios.get('/ums/menu/list')
        this.dataSource = res.data
        this.menuTree.treeData = res.data
      } catch (e) {}
      this.loading = false
    },
  },
  async mounted() {
    this.systemType = await getSystemType()
    this.loadMenu()
  },
}
</script>

<style lang="less" scoped>
.menu-name {
  display: block;
  margin-top: -21px;
}
::v-deep {
  .ant-table-row-level-0 {
    .menu-name {
      margin-left: 25px;
    }
  }
  .ant-table-row-level-1 {
    .menu-name {
      margin-left: 45px;
    }
  }
  .ant-table-row-level-2 {
    .menu-name {
      margin-left: 65px;
    }
  }
  .ant-table-row-level-3 {
    .menu-name {
      margin-left: 85px;
    }
  }
}

.tabs {
  width: 100%;
  height: 38px;
  background: #eeeeee;
  border-radius: 4px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-bottom: 20px;
  display: flex;
  .btn {
    width: 100px;
    height: 100%;
    line-height: 38px;
    text-align: center;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
  }
  .active {
    background: #ffffff;
  }
}
.row-action-btn {
  margin: 0 5px;
}
</style>
